import { DocumentTypeEnum } from "./enums/ListUtility";

export function resolveDocumentType(file: File): DocumentTypeEnum {
  const mime = file.type.toLowerCase();

  if (mime === "application/pdf") return DocumentTypeEnum.PDF;
  if (mime === "image/webp") return DocumentTypeEnum.WEBP;
  if (mime === "image/png") return DocumentTypeEnum.PNG;
  if (mime === "image/jpeg" || mime === "image/jpg") return DocumentTypeEnum.JPG;

  return DocumentTypeEnum.Other;
}
